export default (err) => {
    if(!err.response) return toastr.error(err.message);

    const { data: { errors } } = err.response;
    const messages = [];
    Object.keys(typeof(errors) !== 'undefined'?errors: {}).map(key => {
        const fieldErrors = errors[key];
        fieldErrors.map(errMsg => messages.push(errMsg));
    });

    return toastr.error(messages.join('\n'));
}